import { cardPartCss } from '../surface';

import type { ArmSpec } from '../armRegistry';
import type { ProfileCard } from '../surface';

const CHIP = 'Full text';
const FLAG = 'fulltextfirst';

function marked(card: ProfileCard): boolean {
  return card.flag(FLAG) != null;
}

function mixed(cards: ProfileCard[]): boolean {
  return (
    cards.some((card) => card.hasDownloadable) &&
    cards.some((card) => !card.hasDownloadable)
  );
}

// Stable: alike works keep the recency order the page rendered them in.
function downloadableFirst(a: ProfileCard, b: ProfileCard): number {
  if (a.hasDownloadable === b.hasDownloadable) return 0;

  return a.hasDownloadable ? -1 : 1;
}

function badgeFullText(cards: ProfileCard[]): void {
  cards.forEach((card) => {
    if (!card.hasDownloadable || marked(card)) return;

    card.setFlag(FLAG);
    card.addChip(CHIP);
  });
}

export const fullTextOnlyFirst: ArmSpec = {
  stamp: (ctx) => ({
    render_state: mixed(ctx.cards()) ? 'rendered' : 'fallback',
  }),

  onReady: (ctx) => {
    const cards = ctx.cards();
    if (!mixed(cards)) return;

    ctx.injectStyles(
      cardPartCss(
        'chip',
        ctx.scope,
        'background: #0954d3; border-radius: 100px; padding: 2px 8px; ' +
          'color: #fff;',
      ),
    );
    ctx.reorderCards(downloadableFirst);
    badgeFullText(cards);
  },

  // No reorder here: an appended batch must not move cards under a reader who is
  // already scrolling them. Gated on the mark onReady left rather than on a
  // fresh read, so a late batch cannot engage an arm that degraded to control.
  onCards: (cards, ctx) => {
    if (!ctx.cards().some(marked)) return;

    badgeFullText(cards);
  },
};
